import React, { FC } from 'react';
import { Box, ListItem, ListItemIcon, ListItemText } from '@mui/material';

interface ActionListItemComponentProps {
    text: string;
    children: React.ReactNode;
    icon: React.ReactNode;
}

const ActionListItemComponent: FC<ActionListItemComponentProps> = (props) => {
    const { text, children, icon } = props;

    return (
        <ListItem
            sx={{
                backgroundColor: 'grey10.main',
                '&:not(:last-child)': {
                    borderBottomColor: 'grey200.main',
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                },
            }}
            data-testid="ActionListItemComponent"
        >
            <Box sx={{
                backgroundColor: 'grey600.main',
                m: -2,
                mr: 2,
                height: '49px',
                width: '50px',
                display: 'flex',
                '&:not(:last-child)': {
                    borderBottomColor: '#fff',
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                },
            }}
            >
                <ListItemIcon sx={{ justifyContent: 'center', alignItems: 'center', minWidth: '50px' }}>
                    {icon}
                </ListItemIcon>
            </Box>

            <ListItemText primary={text} />
            <Box sx={{ m: -1, mr: 1 }}>
                {children}
            </Box>

        </ListItem>
    );
};

export default ActionListItemComponent;
